module.exports = __webpack_public_path__ + "img/益视说明书_13.770501cb.png";